<template>
  <v-layout class="mt-5 text-xs-center">
    <v-flex v-for="(l, i) in socialLinks" :key="i">
      <a :href="l.link" class="white--text" target="_blank">
        <v-icon size="50px">{{ l.icon }}</v-icon>
      </a>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'Social',
  data() {
    return {
      socialLinks: [
        {
          icon: 'mdi-facebook-box',
          link: 'https://www.facebook.com/tinynoiz',
        },
        {
          icon: 'mdi-twitter-circle',
          link: 'https://www.twitter.com/tinynoiz',
        },
      ],
    };
  },
};
</script>
